import { PrivacyPolicy } from '../../../component/auth/legal/privacy-policy'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

export const PrivacyPolicyScreen = (): React.ReactElement => {
  return (
    <Container>
      <Row>
        <Col>
          <PrivacyPolicy />
        </Col>
      </Row>
    </Container>
  )
}
